module.exports = __webpack_public_path__ + "static/media/Banana.f521a6dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Banana.png
// module id = 598
// module chunks = 0